import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import PrimeReact from "primereact/api";

import { getLocalStorage, setLocalStorage } from "../services/LocalStorage";
// import laraLight from "../../../../assets/themes/lara/lara-light/blue/theme.scss";
import laralight from "../assets/themes/lara/lara-light/blue/theme.scss";

export const LanguageContext = React.createContext(undefined);
export const CustomThemeContext = React.createContext(undefined);
export const HotelContext = React.createContext(undefined);
export const LoginContext = React.createContext({
  isAuth: false,
  user: "",
  setAuth: () => {},
});

function GlobalProvider({ children }) {
  //Language Provider
  const [language, setLanguage] = useState(
    getLocalStorage("language") ||
      (navigator.language.split("-")[0].toUpperCase() !== "EN" &&
      navigator.language.split("-")[0].toUpperCase() !== "FR"
        ? "EN"
        : navigator.language.split("-")[0].toUpperCase())
  );

  const { t, i18n } = useTranslation();
  const languages = [
    { label: t("language_EN"), name: "EN" },
    { label: t("language_FR"), name: "FR" },
  ];

  const onClickLanguageChange = e => {
    setLanguage(e.target.value);
    setLocalStorage("language", language);
  };
  useEffect(() => {
    i18n.changeLanguage(language);
    setLocalStorage("language", language);
  }, [i18n, language]);

  //Select Hotel provider
  const [selectedHotel, setSelectedHotel] = useState(() =>
    getLocalStorage("defaultHotelId")
  );
  //for login/logout
  const [isAuth, setAuth] = useState(getLocalStorage("isAuth") || false);
  const [user, setUser] = useState(getLocalStorage("user"));

  //for theme
  const [darkMode, setDarkMode] = useState(false);

  //declaration  of theme variable
  const [theme, setTheme] = useState("dark");

  const changePrimeReactTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    PrimeReact.changeTheme?.(
      `lara-${theme}-blue`,
      `lara-${newTheme}-blue`,
      "app-theme",
      () => setTheme(newTheme)
    );
  };

  const changeTheme = theme => {
    import(`../assets/mythemes/lara/${theme}/blue/theme.css`).then(
      module => {}
    );
  };
  //for theme
  useEffect(() => {
    darkMode ? changeTheme("lara-dark") : changeTheme("lara-light");
  }, [darkMode]);

  //for selected hotel
  useEffect(() => {
    setLocalStorage("defaultHotelId", selectedHotel);
  }, [selectedHotel]);

  //is login /logout
  useEffect(() => {
    setLocalStorage("isAuth", isAuth);
  }, [isAuth]);

  return (
    <LanguageContext.Provider
      value={{
        t,
        i18n,
        language,
        onClickLanguageChange,
        languages,
      }}
    >
      <LoginContext.Provider value={{ isAuth, user, setAuth }}>
        <CustomThemeContext.Provider
          value={{ theme, setTheme, changePrimeReactTheme }}
        >
          <HotelContext.Provider value={{ darkMode, setDarkMode }}>
            {children}
          </HotelContext.Provider>
        </CustomThemeContext.Provider>
      </LoginContext.Provider>
    </LanguageContext.Provider>
  );
}
export const useLanguageContext = () => useContext(LanguageContext);
export const useHotelContext = () => useContext(HotelContext);
export const useAuthContext = () => useContext(LoginContext);
export const useThemeContext = () => useContext(CustomThemeContext);
export default GlobalProvider;
